import { defineComponent as _defineComponent } from 'vue'
import { THGDonationProject } from '@/interfaces/thg/THGDonationProject';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import { computed, ref } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { Country } from '@/enums/Country';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGDonationProjectsCheckboxGroup',
  props: {
    user: null,
    disabled: { type: Boolean }
  },
  emits: ["updateProjects"],
  setup(__props: any, { emit }: { emit: ({
        // eslint-disable-next-line no-unused-vars
        (e: 'updateProjects', value: string[]): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        user: THGUser;
        disabled: boolean;
    };

    const { currentCountry } = storeToRefs(useTHGGlobalStore());

    

    const projects = ref<string[]>(props.user.donation_projects);

    

    // get the donation projects according to current country
    const donationProjects = computed(() => {
        if (currentCountry.value === Country.AT) {
            return donationProjectsAT;
        }

        return donationProjectsDE;
    });

    const donationProjectsDE: THGDonationProject[] = [
        {
            title: 'Deutsche Umwelthilfe',
            slug: 'deutsche-umwelthilfe',
            href: 'https://duh.de',
            is_active: true,
        },
        {
            title: 'Tafel Deutschland',
            slug: 'tafel-deutschland',
            href: 'https://www.tafel.de/',
            is_active: true,
        },
        {
            title: 'Deutsches Rotes Kreuz',
            slug: 'deutsches-rotes-kreuz',
            href: 'https://drk.de',
            is_active: true,
        },
        {
            title: 'caritas international',
            slug: 'caritas-international',
            href: 'https://www.caritas-international.de',
            is_active: true,
        },
    ];

    const donationProjectsAT: THGDonationProject[] = [
        {
            title: 'WWF',
            slug: 'wwf',
            href: 'https://www.wwf.at',
            is_active: true,
        },
        {
            title: 'Caritas',
            slug: 'caritas',
            href: 'https://www.caritas.at',
            is_active: false,
        },
        {
            title: 'Österreichisches Rotes Kreuz',
            slug: 'oesterreichisches-rotes-kreuz',
            href: 'https://www.roteskreuz.at',
            is_active: true,
        },
        {
            title: 'Licht ins Dunkel',
            slug: 'licht-ins-dunkel',
            href: 'https://https://lichtinsdunkel.orf.at',
            is_active: true,
        },
    ];

return { __sfc: true,currentCountry, props, projects, emit, donationProjects, donationProjectsDE, donationProjectsAT }
}

})